module.exports = __webpack_public_path__ + "img/category-skill-game.2cbda0cd.png";